// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"81387b04","336":"b3230e0d","453":"7fa06f6c","524":"4767aaf5","732":"6292db2c","889":"ac0cdd74"}[chunkId] + ".chunk.js";
};